export default "__VITE_ASSET__DOe4PZ2N__"